import React, { Component } from 'react'
import './Menus.css'
import AuthUserContext from '../../AuthUserContext'

class MenuGroup extends Component {
  constructor (props) {
    super(props)
    this.listenerClickOutside = this.listenerClickOutside.bind(this)
  }
  componentDidMount () {
    document.addEventListener('click', this.listenerClickOutside, true)
  }
  componentWillUnmount () {
    document.removeEventListener('click', this.listenerClickOutside, true)
  }
  listenerClickOutside (ev) {
    if (!this.menuGroup.contains(ev.target)) {
      this.props.closeMenu()
    }
  }
  render () {
    return (
      <AuthUserContext.Consumer>
        {(authUser) => {
          if (authUser.user.id === this.props.admin) {
            return (
              <div className='menu' ref={(menuGroup) => { this.menuGroup = menuGroup }}>
                <ul>
                  <li><a href='#adminGroupMembers' onClick={(ev) => { ev.preventDefault(); this.props.handleModal('adminGroupMembers', { groupId: this.props.id, userId: authUser.user.id }); this.props.closeMenu() }}>Administrar participantes</a></li>
                  <li><a href='#adminGroupDetails' onClick={(ev) => { ev.preventDefault(); this.props.handleModal('adminGroupDetails', { groupId: this.props.id, userId: authUser.user.id }); this.props.closeMenu() }}>Detalles del grupo</a></li>
                  <li><a href='#shareGroup' onClick={(ev) => { ev.preventDefault(); this.props.handleModal('shareGroup', { groupId: this.props.id, userId: authUser.user.id }); this.props.closeMenu() }}>Invitar al grupo</a></li>
                </ul>
              </div>
            )
          } else {
            return (
              <div className='menu' ref={(menuGroup) => { this.menuGroup = menuGroup }}>
                <ul>
                  <li><a href='#editGroup' onClick={(ev) => { ev.preventDefault(); this.props.handleModal('editGroup', { groupId: this.props.id, userId: authUser.user.id }); this.props.closeMenu() }}>Editar grupo</a></li>
                  <li><a href='#exitGroup' onClick={(ev) => { ev.preventDefault(); this.props.handleModal('exitGroup', { groupId: this.props.id, userId: authUser.user.id }); this.props.closeMenu() }}>Abandonar grupo</a></li>
                  <li><a href='#shareGroup' onClick={(ev) => { ev.preventDefault(); this.props.handleModal('shareGroup', { groupId: this.props.id, userId: authUser.user.id }); this.props.closeMenu() }}>Invitar al grupo</a></li>
                </ul>
              </div>
            )
          }
        }}
      </AuthUserContext.Consumer>
    )
  }
}

export { MenuGroup }
